export { LandingTemplate } from './LandingTemplate';
export { VideoLandingTemplate } from './VideoLandingTemplate';
export { SpeechToTextLandingTemplate } from './SpeechToTextLandingTemplate';
